(() => {
  if (window.dorelanEventsLoaded) return;
  window.dorelanEventsLoaded = true;

  const contextElement = document.querySelector('[data-dorelan-tracking-context]');
  const context = contextElement ? JSON.parse(contextElement.textContent) : {};
  const text = (element) => element?.textContent.trim().replace(/\s+/g, ' ') || '';

  function pushEvent(eventData) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'ga4_event', ...eventData });
    console.debug('Pushed event:', eventData);
  }

  function storeDetails(element) {
    let storeName;
    let storeCity;

    const dialog = element.closest('[role="dialog"]');
    if (!!dialog) {
      storeName = dialog?.querySelector(".storepoint-location-popup-header-title")?.textContent.trim() || "";
      storeCity = dialog?.querySelector("[data-cft='n9kxdtpu6g'] .storepoint-cf-text-value")?.textContent.trim() || "";
    } else {
      const listItem = element.closest('.storepoint-location');
      if (!!listItem) {
        storeName = listItem?.querySelector(".storepoint-name")?.textContent.trim() || "";
        storeCity = listItem?.querySelector("[data-cft='n9kxdtpu6g'] .storepoint-cf-text-value")?.textContent.trim() || "";
      } else {
        const store = element.closest('.strmpr-search-result, .storemapper-popup-container, .strmpr-map-popup, [data-store-name]');
        const address = text(store?.querySelector('.strmpr-field-address'));
        const postalCity = address.match(/(?:^|,)\s*(?:[A-Z]{1,2}[- ]?)?\d{4,6}\s+([^,\d]+?)(?:\s*\([A-Z]{2}\)|,|$)/i);

        storeName = store?.dataset.storeName || text(store?.querySelector('.strmpr-field-name')) || context.store_name || '';
        storeCity = store?.dataset.storeCity || text(store?.querySelector('.strmpr-field-city')) || postalCity?.[1].trim().replace(/\s+[A-Z]{2}$/, '') || (!store ? context.store_city : '') || '';
      }
    }

    return {
      store_name: storeName,
      store_city: storeCity
    };
  }

  function productName(element) {
    return element.closest('[data-product-name]')?.dataset.productName || context.item_name || '';
  }

  function isStoreLocatorLink(link) {
    if (!link) return false;
    try {
      const url = new URL(link.href, window.location.href);
      return /^https?:$/.test(url.protocol) && /^\/(?:[^/]+\/)?pages\/punti-vendita\/?$/.test(url.pathname);
    } catch {
      return false;
    }
  }

  document.addEventListener('dialog:after-show', (event) => {
    const drawer = event.target;
    if (!(drawer instanceof Element) || !drawer.matches('x-drawer[data-choice-guide], x-drawer[id^="size-chart-"]')) return;
    pushEvent({
      event_name: 'product_action',
      event_action: 'click guida scelta',
      item_name: productName(drawer)
    });
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const summary = event.target.closest('.product-info__accordion summary, .product-info-modal-button summary');
    if (summary && productName(summary)) {
      const details = summary.closest('details');
      const trigger = summary.querySelector('[aria-controls]');
      const isOpen = trigger ? trigger.getAttribute('aria-expanded') === 'true' : details.open;
      if (!isOpen) {
        pushEvent({
          event_name: 'product_action',
          event_action: 'open_tab',
          event_detail: text(summary),
          item_name: productName(summary)
        });
      }
    }

    const link = event.target.closest('a[href]');
    const cta = event.target.closest('.product-info__button .button, .dor-mobileMenu__storeLocator, .dor-find-store-footer, [data-store-cta]') ||
      (isStoreLocatorLink(link) ? link : null);
    if (cta) {
      let ctaText = text(cta);
      if (!ctaText && cta.parentElement.tagName == "IMAGE-BANNER") {
        const proxyButton = cta.parentElement.querySelector(`a.button[href="${cta.getAttribute("href")}"]`);
        if(proxyButton) {
          ctaText = text(proxyButton);
        }
      }

      pushEvent({
        event_name: 'product_action',
        event_action: 'click_cta',
        event_detail: ctaText,
        item_name: productName(cta)
      });
    }

    if (!link) return;
    const href = link.getAttribute('href').trim();
    let action;
    if (/^tel:/i.test(href)) {
      action = 'click_tel';
    }
    if (/^mailto:/i.test(href)) {
      action = 'click_mail';
    }
    if (link.closest('.dor-store-directions, .strmpr-field-directions') || link.classList.contains("storepoint-popup-directions")) {
      action = 'click_raggiungici';
    }
    if (action) {
      pushEvent({ event_name: 'store_action', event_action: action, ...storeDetails(link) });
    }

    const isStandaloneGuide = document.querySelector('[data-choice-guide-page]') &&
      !link.closest('x-drawer') &&
      (link.matches('[data-choice-guide-link]') ||
        (link.matches('.rich-text__wrapper a.button') && /\.pdf(?:[?#]|$)/i.test(href)));
    if (isStandaloneGuide) {
      pushEvent({
        event_name: 'product_action',
        event_action: 'click guida scelta',
        item_name: 'page guida scelta'
      });
    }
  }, true);

})();